import { Article } from '@/modules/articles/model/article';
import { DateFormat } from '@/core/date/export';
import { UpgradePanel } from '@/shared/session/export';
import { TaggedHeadline } from '@/shared/badges/export';
import BookmarkButton from '@/modules/articles/components/bookmarks/bookmark-button';
import ArticleBodyDisplay from '@/modules/articles/components/articles/article-body-display';
import embedLocationInXhtml from '@/modules/articles/util/embedLocationInXhtml';
import { useSessionIdentity } from '@/core/auth/export';

export default function ArticleView({
  article,
  onClose,
  showBookmark = true,
  showBack = true,
  showPin = true,
}: {
  article: Article;
  onClose: Function;
  showBookmark?: boolean;
  showBack?: boolean;
  showPin?: boolean;
}) {
  const xhtml = embedLocationInXhtml(article);
  const identity = useSessionIdentity();

  return (
    <div className="container-element mh-100">
      <div className="container-responsive-text mh-100 overflow-auto m-2">
        <div className={'sticky-top z-1'}>
          <div className={'d-flex '}>
            <div className={'me-auto'}>
              <h3>
                <TaggedHeadline headline={article.headline} />
              </h3>
            </div>

            <div className={'text-end'}>
              <span className={'pt-1'}>
                {showBookmark && (
                  <span className={'me-1'}>
                    <BookmarkButton article={article} />
                  </span>
                )}
              </span>
            </div>
          </div>
        </div>

        <hr />

        <div className={'d-flex justify-content-between small'}>
          <div className={'text-muted'}>
            <DateFormat format={'MMM D, YYYY, h:mm a'} date={article.firstcreated} />
          </div>
          <em>By {article.byline}</em>
        </div>

        <div className={'mt-3'}>
          <ArticleBodyDisplay article={article} xhtml={xhtml} />
        </div>

        {article.representationtype === 'partial' && (
          <div className={'text-center'}>
            <div className={'col-container-sm-8 offset-container-sm-2'}>
              <div className={'card bg-black shadow-lg border border-primary'}>
                <UpgradePanel contentName={`Article: ${article.headline}`} identity={identity} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
